<template>
  <div class="card-header" v-if="totalLiveStream">
    <div class="row">
      <div class="col-7">
        <h3>Current Live Stream</h3>
      </div>
      <div class="col-5" align="right">
        <span class="live-stream-count">{{ `${totalLiveStream} Live Streams` }}</span>
      </div>
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12 mt-4" v-for="liveStream in currentLiveStreams" :key="liveStream.id">
        <!-- <router-link to="#"> -->
        <div
          class="row"
          style="cursor: pointer;"
          @click="onCurrentLiveStreamItemClicked(liveStream.id)"
        >
          <div class="col-6">
            <img
              class="rounded thumbnail"
              :src="liveStream.thumbnail ? liveStream.thumbnail : require('@/assets/default_live_stream_thumbnail.jpg')"
              alt
            />
          </div>
          <div class="col-6 content">
            <h5 class="text-overflow">{{ liveStream.title }}</h5>
            <p class="text-overflow text-light description">{{ liveStream.description }}</p>
            <div class="align-bottom">
              <span class="small text-light streamer-name">{{ liveStream.streamer.name }}</span>
            </div>
          </div>
        </div>
        <!-- </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { GET_CURRENT_LIVE_STREAMS } from '@/store/actions.type'

export default {
  name: 'current-live-stream-list',
  data() {
    return {}
  },
  mounted() {
    this.$store.dispatch(GET_CURRENT_LIVE_STREAMS)
  },
  methods: {
    onCurrentLiveStreamItemClicked(id) {
      this.$router.push({ path: '/live_stream/' + id })
    }
  },
  computed: {
    ...mapState({
      totalLiveStream: state => state.liveStream.totalCurrentLiveStream
    }),
    ...mapGetters(['currentLiveStreams'])
  }
}
</script>

<style scoped>
.card-header {
  border-radius: 5px !important;
  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2),
    0 6px 20px 0 rgba(92, 92, 92, 0.19);
}
.live-stream-count {
  color: #962100;
  font-size: 13px !important;
}
.thumbnail {
  max-width: 100% !important;
}
.content {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.text-overflow {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.block-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 43px;
  margin: 0 auto;
  font-size: 12px;
  line-height: 1;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.description {
  font-size: 12px;
}

.text-light {
  color: rgba(102, 102, 102, 0.8) !important;
}
.streamer-name {
  position: absolute;
  bottom: 0;
  left: 0;
}
.align-bottom {
  position: relative;
  min-height: 45px;
}
.col-12 hr {
  border-top: 0.5px solid rgba(220, 220, 220, 0.7) !important;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
</style>
